"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconNameEnum = void 0;
var IconNameEnum;
(function (IconNameEnum) {
    IconNameEnum["Wallet"] = "Wallet";
    IconNameEnum["WalletFilled"] = "WalletFilled";
    IconNameEnum["Profits"] = "Profits";
    IconNameEnum["ProfitsFilled"] = "ProfitsFilled";
    IconNameEnum["Trades"] = "Trades";
    IconNameEnum["TradesFilled"] = "TradesFilled";
    IconNameEnum["Dividends"] = "Dividends";
    IconNameEnum["DividendsFilled"] = "DividendsFilled";
    IconNameEnum["AccountingDocument"] = "AccountingDocument";
    IconNameEnum["Bell"] = "Bell";
    IconNameEnum["BellFilled"] = "BellFilled";
    IconNameEnum["ChartBar"] = "ChartBar";
    IconNameEnum["HeartFilled"] = "HeartFilled";
    IconNameEnum["Heart"] = "Heart";
    IconNameEnum["CompoundInterest"] = "CompoundInterest";
    IconNameEnum["ChartBarFilled"] = "ChartBarFilled";
})(IconNameEnum = exports.IconNameEnum || (exports.IconNameEnum = {}));
//# sourceMappingURL=icon-name-enum.js.map